<template>
  <div class="intro">
    <p class="h6 text-center">
      Welcome to ATOM! Below are each of the modules that you can access in this program.
    </p>
    <hr />
    <b-container class="my-5 p-0">
      <b-row>
        <b-col cols="12" md="4" lg="4" xl="4" v-for="(module, idx) in modules" :key="idx">
          <b-card
            :title="module.name"
            :img-src="module.icon"
            :alt="module.alt"
            img-top
            class="shadow atm-rounded m-2 py-4 text-center"
          >
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  props: {
    modules: Array,
  },
};
</script>

<style scoped>
.card-img,
.card-img-bottom,
.card-img-top {
  flex-shrink: 0;
  width: 30%;
  margin: 10px auto;
}
</style>
